import { z } from "zod";

/**
 * Password rule shared by every UI flow that sets a new password:
 * /accept-invite, /reset-password, and the change-password section in
 * /settings/profile. The backend (`usersRouter.acceptInvite`) applies the
 * same rule — keep these in sync.
 *
 *  - ≥ 12 characters
 *  - at least one letter
 *  - at least one digit
 */
export const passwordSchema = z
	.string()
	.min(12, "Password must be at least 12 characters")
	.regex(/[A-Za-z]/, "Password must contain a letter")
	.regex(/[0-9]/, "Password must contain a number");
